<template>
  <v-card flat tile color="secondary">
    <v-card-text class="pt-2 pb-1">
      <v-toolbar flat color="secondary" height="35" class="ma-0">
        <a-chip   class="label-s"       
              outlined small label>
          {{
              surveyType === "survey" ? $t("poll.btnSurvey") : $t("poll.btnPoll")
          }}
        </a-chip>
        <v-spacer></v-spacer>
        <RespondedMsg v-if="surveyDetails.user_responded && tab == 'question'"></RespondedMsg> 
        <v-spacer></v-spacer>
        <a-chip class="label-s ma-2" small :color="surveyStatus.color" outlined>
          {{ surveyStatus.text }}
        </a-chip>

        <span class="subtitle" v-if="!isMobile">

          <strong><span v-if="surveyStatus.value === 'upcoming'">{{
              $t("poll.lblStartsOn")
          }}</span>
            <span v-else>{{ $t("poll.lblStartedOn") }}</span>
            :</strong>
          {{ commencementDate }}
          <v-spacer></v-spacer>
          <strong><span v-if="surveyStatus.value === 'expired'">{{
              $t("poll.lblExpiredOn")
          }}</span>
            <span v-else>{{ $t("poll.lblExpiresOn") }}</span>
            :</strong>
          {{ expiryDate }}
        </span>

      </v-toolbar>
      <v-expansion-panels v-model="panel" tile flat style="z-index: 0">
        <v-expansion-panel class="pa-0">
          <v-expansion-panel-header :hide-actions="isIconDisabled" style="padding: 0px 8px 0px 0px; min-height: 40px">
            <h2 class="mt-2 mb-2" style="overflow-wrap: anywhere;">
              {{ surveyTitle }}
            </h2>
            <template v-slot:actions>
              <v-icon color="primary"> $expand </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <div v-if="surveyDescription ? surveyDescription.trim() !== '' : false">
              <v-divider class="mb-2"></v-divider>
              <h3><strong>{{ $t("poll.lblDescription") }}: </strong></h3>
              <div v-html="$sanitizeHtml(surveyDescription)" class="description"></div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>
<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  HtmlEditor,
} from "@syncfusion/ej2-vue-richtexteditor";
import RespondedMsg from './RespondedMsg.vue' 
Vue.use(RichTextEditorPlugin);
export default {
  name: "SurveyDetailsCard",
  components:{
    RespondedMsg
  },
  data() {
    return {
      statusColor: "",
      panel: 0,
      isIconDisabled: false
    };
  },
  provide: {
    richtexteditor: [HtmlEditor],
  },
  props: {
    surveyDetails: {
      type: [Object, Array],
    },
    tab: {
      type: String,
      default: 'question'
    }
  },
  computed: {

    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    surveyTitle() {
      return this.surveyDetails ? this.surveyDetails.title : "Loading...";
    },

    surveyDescription() {
      if(!this.surveyDetails.description) {
        this.isIconDisabled = true;
      }
      else {
        this.isIconDisabled = false;
      }
      return this.surveyDetails ? this.surveyDetails.description : "";
    },

    surveyType() {
      if (this.surveyDetails) {
        return this.surveyDetails.type;
      }
      return "survey";
    },
    surveyStatus() {
      let startDate = new Date(this.surveyDetails.startDate);
      let endDate = new Date(this.surveyDetails.endDate);
      let today = new Date();
      if (startDate > today) {
        return {
          text: this.$t("poll.Upcoming"),
          value: "upcoming",
          color: "primaryDark2 darken-1",
        };
      }
      if (endDate < today) {
        return {
          text: this.$t("poll.Expired"),
          value: "expired",
       color: "Neutral darken-4",
        };
      }
      if (startDate <= today) {
        return {
          text: this.$t("poll.Active"),
          value: "active",
           color: "primary lighten-2",
        };
      }
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    commencementDate() {
      return this.getDateInternationalDate(this.surveyDetails.startDate);
    },
    expiryDate() {
      return this.getDateInternationalDate(this.surveyDetails.endDate);
    },
  },
  methods: {
    getDateInternationalDate(dateString) {
      var Xmas95 = new Date(dateString);
      //alert(this.selectedLang);
      var options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
    },
  },
};
</script>

<style scoped>
::v-deep .description {
  opacity: 0.8 !important;
  padding: 5px;
  margin-top: 10px;
  background-color: var(--v-Neutral-base) !important;
  border : 1px solid var(--v-Neutral-darken2) !important;

}

::v-deep .e-richtexteditor:not(.e-rte-toolbar-enabled) .e-rte-content {
  background-color: var("--v-appBarT-base") !important;
  border: none !important;
  color: black;
}

::v-deep .e-richtexteditor:not(.e-rte-toolbar-enabled) {
  border: none !important;
  background-color: var("--v-appBarT-base") !important;
}

.basil {
  background-color: #e1efff !important;
}

.basil--text {
  color: white !important;
}

::v-deep .v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 1px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0px;
}

::v-deep .v-expansion-panel {
  background-color: transparent !important;
}
</style>